function HomeContentTabs({ tabs = [], activeTab = "", onTabChange }) {
  return (
    <div
      className="home-content-tabs"
      role="tablist"
      aria-label="Home Content sections"
    >
      {tabs.map((tab) => {
        const isActive = tab.id === activeTab;
        const Icon = tab.Icon;
        return (
          <button
            key={tab.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`home-content-tab ${isActive ? "is-active" : ""}`}
            onClick={() => onTabChange?.(tab.id)}
          >
            <span className="home-content-tab-icon-wrap">
              {Icon ? <Icon size={24} stroke={1.7} /> : null}
            </span>
            <span className="home-content-tab-label">{tab.label}</span>
          </button>
        );
      })}
    </div>
  );
}

export default HomeContentTabs;
